import { DialogTitle, Stack } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { useAssetRegisterNameValidation } from "routes/asset-register/hooks/use-asset-register-name-validation"

export function RenameRegisterDialog({ source }) {
    const { validateRegisterName, isValid, prepareOutput } = useAssetRegisterNameValidation(source)

    return (
        <DataInputDialog initialValue={source} okDisabled={isValid} beforeOk={prepareOutput}>
            <DialogTitle sx={{ mb: 3 }}>Rename Asset Register</DialogTitle>

            <Stack spacing={2} sx={{ mx: 3 }}>
                <BoundTextField
                    autoFocus
                    field="name"
                    label="Title"
                    inputProps={{ maxLength: 100, "data-cy": "rename-register-input" }}
                    yup={validateRegisterName}
                />
            </Stack>
        </DataInputDialog>
    )
}
